module.exports = __webpack_public_path__ + "assets/f2ebc514b2935d703567a919ade82fc1.mp4";